import global from '../../../shared/utils/global.js';
import { fetchCustomers } from './customers.api.js';
import { fetchServiceAgentAccounts, fetchServiceAgentAcitveAccount } from '../../auth/views/login/auth.api.js';
import { main } from '../../../modules/units/unit-sensors/views/main/mainpage.js';
import { openUsersForm } from './usersview.js';
import { findTopLevelCustomer, displayCustomerHierarchy } from './customersview.js';
import { showServiceAgentCustomerModal } from './serviceagentcustomers.js';

const getCustomerHierarchy = async (customerId, serviceAgentAccount) => {

  const customerData = await fetchCustomers();
  const selectedCustomer = customerData.find(c => c.customerId === customerId);
  global.customerId = selectedCustomer.customerId;
  if (serviceAgentAccount && customerData && customerData.length > 0) {

    if (selectedCustomer) {
      displayCustomerHierarchy(customerData, selectedCustomer, true);
      //return; // Done, don’t continue to admin/normal user logic
    }
  } else {
    if (customerData && customerData.length > 0) {

      const topLevelCustomer = findTopLevelCustomer(customerData);
      if (customerData.length > 1) {
        displayCustomerHierarchy(customerData, topLevelCustomer, true);
      } else {
        main();
      }
    } else {
      main();
    }
  }
};

const selectCustomer = (userRole, customerId) => {

  global.customerId = customerId;

  if (userRole != 'ServiceAgent') getCustomerHierarchy(customerId, false);

  const selectCustomerItem = document.getElementById('selectcustomer');
  if (!selectCustomerItem) {
    console.warn('Element with ID "selectCustomerItem" not found.');
    return;
  }

  selectCustomerItem.onclick = async (e) => {
    if (userRole === 'ServiceAgent') {
      const activeAccount = await fetchServiceAgentAcitveAccount();
      getCustomerHierarchy(activeAccount.customerId, true);
    } else {
      getCustomerHierarchy(customerId, false);
    }
  };

  selectCustomerItem.classList.remove("disabled");
  selectCustomerItem.style.pointerEvents = "auto";
  selectCustomerItem.style.opacity = "1";
};

const selectServiceAgent = async (parentCustomerId) => {

  const serviceAgentAccountId = await showServiceAgentCustomerModal();
  getCustomerHierarchy(serviceAgentAccountId, true);

  const selectServiceAgentAccountItem = document.getElementById('selectserviceagentaccount');
  if (!selectServiceAgentAccountItem) {
    console.warn('Element with ID "selectServiceAgentAccountItem" not found.');
    return;
  }

  selectServiceAgentAccountItem.onclick = async (e) => {
    const serviceAgentAccountId = await showServiceAgentCustomerModal();
    selectCustomer('ServiceAgent', serviceAgentAccountId);
    getCustomerHierarchy(serviceAgentAccountId, true);
  };

  const activeAccount = await fetchServiceAgentAcitveAccount();
  const isAdmin = account => account?.accessLevel === 'Administrator';

  if (isAdmin(activeAccount) && Object.keys(activeAccount).length > 0) {
    global.serviceAgentAccessLevel = "Administrator";
    enableManageUsersItem();
  } else {
    global.serviceAgentAccessLevel = "Standard";
    const accounts = await fetchServiceAgentAccounts();
    const currentAccount = accounts.find(({ customerId }) => customerId === parentCustomerId);

    if (isAdmin(currentAccount)) {
      enableManageUsersItem();
    }
  }

  selectCustomer('ServiceAgent', parentCustomerId);

  selectServiceAgentAccountItem.classList.remove("disabled");
  selectServiceAgentAccountItem.style.pointerEvents = "auto"; // Enable interaction
  selectServiceAgentAccountItem.style.opacity = "1"; // Restore visibility
};

const enableManageUsersItem = () => {

  const usersManagementItem = document.getElementById('usersmanagement');
  if (!usersManagementItem) {
    console.warn('Element with ID "usersManagementItem" not found.');
    return;
  }
  usersManagementItem.onclick = (e) => {
    e.stopImmediatePropagation();
    openUsersForm();
  };
  usersManagementItem.classList.remove("disabled");
  usersManagementItem.style.pointerEvents = "auto"; // Enable interaction
  usersManagementItem.style.opacity = "1"; // Restore visibility
};

export const handleUserRole = (userRole, customerId) => {

  global.userRole = userRole;
  switch (userRole) {
    case 'Administrator':
      enableManageUsersItem();
    case 'Standard':
      selectCustomer(userRole, customerId);
      break;
    case 'ServiceAgent':
      selectServiceAgent(customerId);
      break;
    case 'Driver':
      global.customerId = customerId;
      main();
      break;
    default:
      console.warn('Unhandled user role:', userRole);
  }
};